import reportOptimoveLogin from "@casino/client/optimove/reportLogin";
import useRequestEmailVerification from "@casino/legacy/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/useHandleRegister/useRequestEmailVerification";
import setDataToGib from "@casino/legacy/client/components/Auth/Shared/utils/setDataToGib";
import startFraudEngine from "@casino/legacy/client/shared/fraud/fraudEngine";
import useCheckWalletAuthErrors from "@casino/legacy/client/shared/WalletAuthentication/hooks/useCheckWalletAuthErrors";
import useAccountPopoverStore from "@casino/legacy/client/store/useAccountPopoverStore";
import nativeReplace from "@casino/legacy/shared/utils/router/nativeReplace";
import type { ErrorsFragment } from "@workspace/casino_core/mutations/UpdateUserSettingsMutation";
import { setCookie } from "@workspace/cookies/browser";
import type { FieldValues, UseFormSetError } from "react-hook-form";

type MetamaskResponseArgs<T extends FieldValues> = {
  data: ResponseData;
  setError?: UseFormSetError<T>;
  setErrors?: (errorsFragment: GenericErrorType[]) => void;
  setOtpError?: () => void;
  otp?: string;
  redirectUrl: string;
  address: string;
};

type ResponseData = {
  token?: string;
  deviceDataToken?: string;
  errors?: Array<ErrorsFragment | undefined>;
  sessionId?: string;
  userManagement?: {
    currentProfile?: {
      _id?: string;
    };
  };
};

const useHandleMetamaskAuthResponse = () => {
  const { handleAuthErrors } = useCheckWalletAuthErrors();
  const { requestEmailVerification } = useRequestEmailVerification();
  const { dismissPopover } = useAccountPopoverStore();
  const handleMetamaskAuthResponse = async <T extends FieldValues>({
    setError,
    setErrors,
    setOtpError,
    redirectUrl,
    data,
    address,
  }: MetamaskResponseArgs<T>) => {
    const { token, deviceDataToken, errors, sessionId, userManagement } = data;
    handleAuthErrors({
      errors,
      setError,
      setErrors,
      setOtpError,
      redirectUrl,
      address,
    });

    if (token) {
      setCookie("token", token);
      startFraudEngine({ deviceDataToken });
      requestEmailVerification();
      dismissPopover(true);
      if (userManagement?.currentProfile?._id && sessionId) {
        setDataToGib(userManagement?.currentProfile?._id, sessionId);
      }
      const optimoveUserId = userManagement?.currentProfile?._id;
      if (optimoveUserId) {
        reportOptimoveLogin(optimoveUserId);
      }
      return nativeReplace(redirectUrl);
    }

    return null;
  };
  return {
    handleMetamaskAuthResponse,
  };
};

export default useHandleMetamaskAuthResponse;
